import {mutations} from './mutations'
import * as actions from './actions'
import * as getters from './getters'
import 'url-search-params-polyfill'

import {
  MODAL_STATES,
  ACTIONS,
  MUTATIONS,
  GETTERS,
  STATES,
  PATHS
} from 'src/config/app'

// import pack from '!!json-loader!src/../package.json?limit=1'

// URL PARAMS
let urlParams = new window.URLSearchParams(window.location.search)

// DEBUG
let debug = process.env.NODE_ENV !== 'production'
// debug = false
if (urlParams.get('_debug') !== null) debug = true
if (urlParams.get('_debug') === 'false') debug = false

// VCONSOLE
let vconsole = process.env.NODE_ENV !== 'production'
vconsole = false
if (urlParams.get('_vconsole') !== null) vconsole = true
if (urlParams.get('_vconsole') === 'false') vconsole = false


const isStage = new RegExp("^(stage|localhost|192\\.168\\.)","i").test(window.location.hostname);


// STATE
const state = {
  // version: pack.version,
  [STATES.debug]: debug,
  [STATES.vconsole]: vconsole,
  [STATES.staging]: isStage,

  // Version
  [STATES.version]: {
    build: 1000,
    date: null,
  },
  
  // LOADING
  [STATES.loading]: {
    progress: 0,
    step: null,
    completed: false
  },

  [STATES.prev_app_state]: null,
  [STATES.app_state]: PATHS.LOADING,
  [STATES.modal_state]: MODAL_STATES.NONE,

  // ROUTE
  [STATES.route]: {
    afterLoad: PATHS.HOME, // default page to show after loading
    curr: {
      parent: null,
      child: null,
    },
    prev: {
      parent: null,
      child: null,
    },
  },
  
}

// EXPORT
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
